import { render } from "./BackerCenterPledgeCard.vue?vue&type=template&id=29f23f43"
import script from "./BackerCenterPledgeCard.vue?vue&type=script&lang=js"
export * from "./BackerCenterPledgeCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__